import { Request } from '@/classes/Request'

// DTA-998 (SOW req 35 / 99): a short-lived link to the PDF of one of the signed-in
// family user's own form submissions.
export const getFormPdfUrl = async (submissionId: string): Promise<string> => {
  return new Promise((resolve, reject) => {
    const req = new Request()
    req
      .post(`/ajax/form_pdf_url`, { form_submission_id: submissionId })
      .then(response => {
        resolve(response.data.url as string)
      })
      .catch(err => {
        reject('Failed to get form PDF: ' + err)
      })
  })
}
